import { formatCurrencyDisplay } from '@/utils/numberFormat';

export const resolveExpenseFeeVoucherFlags = (voucherType) => {
  const normalized = String(voucherType || '').trim().toLowerCase();

  return {
    isSimpleNoteVoucher: normalized === 'simple_note',
    isForeignReceiptVoucher: normalized === 'foreign_receipt',
    isPayrollVoucher: normalized === 'payroll' || normalized === 'nomina',
  };
};

export const resetExpenseFeeTaxSelection = (form = {}) => {
  form.taxType = 'individual';
  form.taxes = [];
  form.taxGroup = null;
};

export const formatExpenseFeeMoney = (value, currencyCode = 'MXN') => {
  return formatCurrencyDisplay(value, {
    currency: String(currencyCode || 'MXN').trim().toUpperCase() || 'MXN',
    maximumFractionDigits: 2,
  });
};

export const formatExpenseFeeTaxBreakdownLine = (item, currencyCode = 'MXN') => {
  const amount = formatExpenseFeeMoney(item?.amount || 0, currencyCode);
  const name = String(item?.name || '').trim();
  const rateValue = Number(item?.rate || 0);
  const rate = Number.isFinite(rateValue) && rateValue > 0
    ? ` ${Number(rateValue.toFixed(6)).toString()}%`
    : '';

  return `${amount} ${name}${rate}`.trim();
};
